import { ShimmerPlaceHolder } from "@faire/deprecated-retailer-visitor-shared/components/Animation/ShimmerPlaceHolder";
import {
  ImageTextLinkTile,
  ImageTextLinkTileStyles,
} from "@faire/deprecated-retailer-visitor-shared/components/Carousel/ImageTextLinkTile";
import { EAEAEA_PIXEL } from "@faire/deprecated-retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { Core } from "@faire/slate/foundation/color";
import { trackSeoSuppliersPageVisualNavCarouselClick } from "@faire/web-api--source/events/seo/click/suppliersPageVisualNavCarousel";
import { ICategoryTile } from "@faire/web-api--source/indigofair/data/ICategoryTile";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { optimizeImageUrlFillRectangle } from "@faire/web/common/images/optimizeImages";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import * as React from "react";
import styled from "styled-components";

interface IProps {
  category: ICategoryTile;
  isCategoryLoading?: boolean;
}

const RECTANGULAR_IMAGE_WIDTH = 204;
const RECTANGULAR_IMAGE_HEIGHT = 272;
const RECTANGULAR_RATIO = 3 / 4;

export const LoggedOutSuppliersPageHeaderCategoryTile: React.FC<IProps> = ({
  category,
  isCategoryLoading,
}) => {
  const isSSR = useIsSSR();
  const imageUrl = category.image
    ? optimizeImageUrlFillRectangle(
        category.image,
        isSSR,
        RECTANGULAR_IMAGE_WIDTH,
        RECTANGULAR_IMAGE_HEIGHT,
        { resizeMethod: "fill" }
      )
    : EAEAEA_PIXEL;

  const categoryImage = IImage.build({
    ...category.image,
    url: imageUrl,
  });

  if (category.cta_link === undefined) {
    return null;
  }

  return (
    <Column>
      {isCategoryLoading ? (
        <Column align="flex-start" data-test-id="tile-placeholder">
          <ShimmerPlaceHolder $aspectRatio={RECTANGULAR_RATIO} />
          <Spacer height="1x" />
          <ShimmerPlaceHolder $height={16} $width={120} />
        </Column>
      ) : (
        <CategoryTile
          keyString={category.category_path_identifier}
          parentCategoryName={category.parent_category_name}
          image={categoryImage}
          imageSizeInfo={{
            width: RECTANGULAR_IMAGE_WIDTH,
            height: RECTANGULAR_IMAGE_HEIGHT,
            ratio: RECTANGULAR_RATIO,
          }}
          text={category.name}
          link={category.cta_link}
          handleStyledLinkOnClick={() =>
            trackSeoSuppliersPageVisualNavCarouselClick(category.cta_link ?? "")
          }
          showBorder
        />
      )}
    </Column>
  );
};

const CategoryTile = styled(ImageTextLinkTile)`
  ${ImageTextLinkTileStyles.Text} {
    color: ${Core.text.primary};
  }
`;
